import { jsx as _jsx } from "react/jsx-runtime";
import { GhostBlock } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
export var GhostText = function() {
    return /*#__PURE__*/ _jsx(GhostBlock, {
        $width: getSpacing(120),
        $height: getSpacing(20)
    });
};
export var GhostHeader = function() {
    return /*#__PURE__*/ _jsx(GhostBlock, {
        $width: getSpacing(120),
        $height: getSpacing("4x")
    });
};
